"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function introspectionResultToPossibleTypes(introspectionResult) {
    return introspectionResult.__schema.types.reduce((typesMap, typeObj) => (Object.assign(Object.assign({}, typesMap), { [typeObj.name]: typeObj.possibleTypes.map(({ name }) => name) })), {});
}
exports.default = introspectionResultToPossibleTypes;
//# sourceMappingURL=introspectionResultToPossibleTypes.js.map